/**
 * created by wang lei
 工具栏修改图片
 *
 */
import React, {Component} from 'react';
import {Input, InputNumber, message, Modal, Tooltip} from "antd";
import link from "./img/link.png";
import linkBlue from "./img/linkBlue.png";
import {buildInsertPicHtml} from "../../toolsSpace/tools/pictureTool/pictureTool";
import {uuid} from "../../../../utils";
import leftSideIcon from "../image/leftside.png";
import leftCenterIcon from "../image/leftCenter.png";
import rightCenterIcon from "../image/rightCenter.png";
import centerIcon from "../image/center.png";
import $Jq from "jquery";
import $ from "jquery";

export default class PictureAmend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            valueImg:'',
            value:'',
            sizeWidth:'',
            sizeHeight:'',
            vspaceValue:'',
            titleValue:'',
            borderValue:0,
            srcValue:'',
            isDisplay:"none",
            isDisplayBlue:'block',
            float: null,
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
        }
    }

    open = (img) => {
        this.state.ratio =img.width/img.height;

        let float = null;
        if(img.style.float){
            float = img.style.float;
        }else{
            let $imgParent = $(img).parent();
            if($imgParent.length > 0){
                if($imgParent.css("textAlign") === "center"){
                    float = "center";
                }
            }
        }
        this.setState({
            valueImg: img,
            sizeWidth: img.width,
            sizeHeight: img.height,
            vspaceValue: img.vspace,
            borderValue: img.border,
            titleValue: img.name,
            srcValue:img.src,
            float
            // float:$Jq(img).parent().is(":contains('center')")?"center":this.state.float,
        })
        this.setState({visible:true})
    };

    onOk = () => {
        let {valueImg,sizeWidth,sizeHeight,vspaceValue,borderValue,titleValue,srcValue,float}= this.state;
        if(this.props.title==="修改图片"){
            valueImg.style.width=sizeWidth+"px";
            valueImg.style.height=sizeHeight+"px";
            valueImg.width=sizeWidth;
            valueImg.height=sizeHeight;
            valueImg.vspace=vspaceValue;
            valueImg.border=borderValue;
            valueImg.title=titleValue;
            valueImg.name=titleValue;
            valueImg.src=srcValue;
            if(float == "center"){
                $Jq(valueImg).parent().css({"text-align":"center"});
                $Jq(valueImg).css("float", "");
            }else {
                $Jq(valueImg).parent().removeAttr("style");
                valueImg.style.float=float;
            }
        }else if (this.props.title==="插入图片"){
            let flag = false
            this.state.newPicType.map((item)=>{
                if(srcValue.indexOf(item) > -1){
                    flag = true
                }
            })
            if(flag){
                let imgHTML = buildInsertPicHtml({url:srcValue,sourceUrl:srcValue, width:sizeWidth,height:sizeHeight,vspace:vspaceValue,border:borderValue,title:titleValue,name:titleValue,float:float})
                this.props.editor.execCommand("inserthtml", imgHTML);
            }else{
                message.error(`图片格式不正确，只能上传以下图片格式：${this.state.newPicType.join("，")}`);
            }
        }
        this.onClose();
    };

    onClose = () => {
        if(typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({visible: false})
    }

    showModal = () => {
        this.setState({
            visible: true
        })
    }

    imageLabelId = "a_"+uuid();
    render() {
        let baseStyle = {marginLeft:15,cursor:"pointer"};
        let defaultStyle = {...baseStyle,border:"1px solid #FFF"};
        let checkedStyle = {...baseStyle,borderTop:"solid 1px #000",borderLeft:"solid 1px #000",borderRight:"solid 1px #DCDCDC",borderBottom:"solid 1px #DCDCDC"};
        return (
            <div>
                <Modal
                    title={this.props.title}
                    visible={this.state.visible}
                    maskClosable={false}
                    width={1000}
                    onCancel={this.onClose}
                    onOk={this.onOk}
                >
                    <div style={{height:'380px',fontSize:"14px",color:"rgba(0, 0, 0, 0.65)"}}>
                        <div style={{marginBottom:'16px'}}>
                            <span>地址：</span>
                            <Input placeholder="" style={{width:'900px'}} value={this.state.srcValue.replace(/.*(\/storage\/[A-Za-z0-9]+).*/, "$1")} onChange={e=>{
                                this.setState({srcValue:e.target.value})
                            }}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{width: '592px', height: '333px'}}>
                                {this.state.srcValue == "" || this.state.srcValue == null || this.state.srcValue == "undefined" ?
                                    <div style={{
                                        textAlign: "center",
                                        lineHeight: "333px",
                                        background: "rgb(242, 242, 242)",
                                        borderRadius: "5px"
                                    }}>请填写图片地址</div> : <img id={this.imageLabelId} src={this.state.srcValue} style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}/>}
                            </div>
                            <div style={{width:'40%' ,marginLeft:'32px'}}>
                                <div style={{height:32,margin:'16px 0',display:"flex",lineHeight: "32px"}} >
                                    大小：宽度 &nbsp; <InputNumber style={{width: 77}} min={0} value={this.state.sizeWidth}
                                                       onChange={value => {
                                                           if(!this.state.ratio){//解决网络图片地址插入的时候，宽高无法自适应
                                                               let width = parseInt($(`#${this.imageLabelId}`).width());
                                                               let height = parseInt($(`#${this.imageLabelId}`).height());
                                                               this.state.ratio = width/height;
                                                           }
                                                           if (this.state.isDisplayBlue == "block") {
                                                               this.setState({
                                                                   sizeWidth: value*1,
                                                                   sizeHeight: (value / this.state.ratio).toFixed(0)*1
                                                               })
                                                           } else {
                                                               this.setState({sizeWidth: value*1})
                                                           }
                                                       }}/>
                                    <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                                    <img src={link} style={{margin: '5px 10px 0 10px',height:21,display: this.state.isDisplay,cursor:"pointer"}}
                                         onClick={() => {
                                             this.setState({isDisplayBlue:"block",isDisplay:"none"})
                                         }}
                                    />
                                    <img src={linkBlue} style={{margin: '5px 10px 0 10px',height:21,display: this.state.isDisplayBlue,cursor:"pointer"}}
                                         onClick={() => {
                                             this.setState({isDisplayBlue:"none",isDisplay:"block"})
                                         }}/>
                                    高度 &nbsp; <InputNumber min={0} style={{width: 77}} value={this.state.sizeHeight}
                                                    onChange={value => {
                                                        if (this.state.isDisplayBlue == "block") {
                                                            this.setState({
                                                                sizeHeight: value*1,
                                                                sizeWidth: (this.state.ratio * value).toFixed(0)*1
                                                            })
                                                        } else {
                                                            this.setState({sizeHeight: value*1})
                                                        }
                                                    }}/>
                                    <span style={{color:"rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                                </div>
                                <div style={{margin:'16px 0'}}>
                                    边框：<InputNumber min={0} value={this.state.borderValue>0?this.state.borderValue:0} onChange={value=>{
                                    this.setState({borderValue:value})
                                }}/>
                                    <span style={{color:"rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                                </div>
                                <div style={{margin:'16px 0'}}>
                                    边距：<InputNumber min={0} placeholder="0" value={this.state.vspaceValue} onChange={value=>{
                                    this.setState({vspaceValue:value})
                                }} />
                                    <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                                </div>
                                <div style={{margin:'16px 0'}}>
                                    描述：<Input placeholder="" style={{width:'230px'}} value={this.state.titleValue} onChange={e=>{
                                    this.setState({titleValue:e.target.value})
                                }} />
                                </div>
                                <div>
                                    浮动方式：
                                    <Tooltip title={"无浮动"} onClick={()=>{this.setState({float:null})}}><img style={this.state.float===null?checkedStyle:defaultStyle} src={leftSideIcon}/></Tooltip>
                                    <Tooltip title={"左浮动"} onClick={()=>{this.setState({float:"left"})}}><img style={this.state.float==="left"?checkedStyle:defaultStyle} src={leftCenterIcon}/></Tooltip>
                                    <Tooltip title={"右浮动"} onClick={()=>{this.setState({float:"right"})}}><img style={this.state.float==="right"?checkedStyle:defaultStyle} src={rightCenterIcon}/></Tooltip>
                                    <Tooltip title={"居中独占一行"} onClick={()=>{this.setState({float:"center"})}}><img style={this.state.float==="center"?checkedStyle:defaultStyle} src={centerIcon}/></Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }

}